import axios from "axios";
import { useEffect } from "react";
import { useAuth } from "./userService";

let baseURL;

if (import.meta.env.MODE && import.meta.env.MODE === "development") {
	// dev code
	baseURL = "http://localhost:8080";
} else {
	// production code
	baseURL = window.location.protocol + "//" + window.location.host + "/api";
}

export const apiURL = baseURL;

const axiosInstance = axios.create({
	baseURL: baseURL,
	timeout: 30000,
});

const privateAxiosInstance = axios.create({
	baseURL: baseURL,
	timeout: 30000,
});

export const usePublicAPI = () => {
	return axiosInstance;
}

export const useProtectedAPI = () => {

	const { auth, setIsLoading } = useAuth();
	const refresh = useRefreshToken()

	/*const protectedAPI = axios.create({
		baseURL: baseURL,
		timeout: 30000
	})*/

	useEffect(() => {

		const requestInterceptor = privateAxiosInstance.interceptors.request.use(
			config => {
				// console.log(auth, auth?.accessToken)
				if (auth?.accessToken) {
					config.headers['Authorization'] = `Bearer ${auth?.accessToken}`;
				}
				return config;
			}, (error) => Promise.reject(error)
		);

		const responseInterceptor = privateAxiosInstance.interceptors.response.use(
			response => response,
			async (error) => {
				const prevRequest = error?.config;
				if (error.response) {
					if (error?.response?.status === 401 && !prevRequest.sent && auth && !auth.isIdpLoading && !auth.fromIdp) {
						prevRequest.sent = true;
						const newAccessToken = await refresh();
						prevRequest.headers['Authorization'] = `Bearer ${newAccessToken}`;
						return privateAxiosInstance(prevRequest);
					}
					return Promise.reject(error);
				}
		
				return Promise.reject(error);
			},
		);

		if(auth?.isLoading && auth.accessToken)
			setIsLoading(false);

		return () => {
			privateAxiosInstance.interceptors.request.eject(requestInterceptor);
			privateAxiosInstance.interceptors.response.eject(responseInterceptor);
		};

	}, [auth, refresh, setIsLoading])


	return privateAxiosInstance;

}



export const useRefreshToken = () => {
	// const { setAccessToken } = useAuth();

	const publicAPI = usePublicAPI()

	const refresh = async () => {
		// console.log('apiService::useRefreshToken::refresh')
		
		const response = await publicAPI.get("/oauth2/refresh", {
			withCredentials: true,
		});
		
		// setAccessToken(response.data.access_token);

		return response.data.access_token;
	}

	return refresh;
}